import React from 'react';

export const AddIcon = ({
  className,
  showCircle = true,
}: {
  className?: string;
  showCircle?: boolean;
}) =>
  showCircle ? (
    <svg className={className} viewBox="0 0 20 20">
      <circle cx="10" cy="10" r="9" fill="none" vectorEffect="non-scaling-stroke" />
      <path d="M10 5 L 10 15" fill="none" strokeLinecap="round" vectorEffect="non-scaling-stroke" />
      <path d="M5 10 L 15 10" fill="none" strokeLinecap="round" vectorEffect="non-scaling-stroke" />
    </svg>
  ) : (
    <svg className={className} viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path
        d="M8 3.5V12.5M3.5 8H12.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );

export default AddIcon;
